import {ajax} from '../utils/ajaxHelper';

// TODO make async?
function getRegistrationNumber({listingId}) {
    let url = `/pdp/registrationNumber?listingId=${listingId}`;

    return ajax(url);
}

export default getRegistrationNumber;
export {getRegistrationNumber};
